import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PublicEventsPage from "./pages/PublicEventsPage";
import AdminDashboard from "./pages/AdminDashboard";
import Win2026Page from "./pages/Win2026Page";
import Win2026Admin from "./pages/Win2026Admin";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicEventsPage />} />
          <Route path="/win2026" element={<Win2026Page />} />
          <Route path="/admin/win-2026" element={<Win2026Admin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
